module.exports = __webpack_public_path__ + "static/media/galerija_2019 (43).82b57287.jpg";